import { render } from "./Audience.vue?vue&type=template&id=d04a746e&scoped=true"
import script from "./Audience.vue?vue&type=script&lang=js"
export * from "./Audience.vue?vue&type=script&lang=js"

import "./Audience.vue?vue&type=style&index=0&id=d04a746e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d04a746e"]])

export default __exports__